module.exports = __webpack_public_path__ + "static/media/logo.ed0c6f1d.svg";